export default function AboutSite() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center mb-4">
          なぜ当サイトのクレジットカード比較は信頼できるのか?
        </h2>
        <p className="text-center text-gray-600 mb-12 text-sm sm:text-base">
          当サイト「creditcard-start.com」は、<br className="sm:hidden" />
          これからクレジットカードを作る方が"損をしない選択"をできるよう、<br />
          最新情報と実体験に基づいた比較を行っています。
        </p>

        <div className="space-y-8">
          {/* 運営方針 */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 sm:p-8 border border-teal-100">
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 text-white rounded-xl text-lg shadow-lg">
                <i className="ri-shield-check-line"></i>
              </span>
              運営方針
            </h3>
            <ul className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
              <li className="flex items-start gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-6 h-6 flex items-center justify-center text-teal-600 mt-0.5 flex-shrink-0">
                  <i className="ri-refresh-line text-lg"></i>
                </span>
                <span><strong className="text-gray-900">年会費、還元率、キャンペーン内容を定期更新</strong><br />
                各カード会社の最新情報を常にチェックし、変更があれば速やかに反映しています</span>
              </li>
              <li className="flex items-start gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-6 h-6 flex items-center justify-center text-teal-600 mt-0.5 flex-shrink-0">
                  <i className="ri-file-list-3-line text-lg"></i>
                </span>
                <span><strong className="text-gray-900">公式サイト情報を必ず確認</strong><br />
                すべての情報は各カード会社の公式サイトをもとに掲載しています</span>
              </li>
              <li className="flex items-start gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-6 h-6 flex items-center justify-center text-teal-600 mt-0.5 flex-shrink-0">
                  <i className="ri-scales-3-line text-lg"></i>
                </span>
                <span><strong className="text-gray-900">メリットだけでなくデメリットも明記</strong><br />
                良い点だけでなく、注意点やデメリットも正直にお伝えします</span>
              </li>
            </ul>
          </div>

          {/* 比較基準 */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 sm:p-8 border border-amber-100">
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-500 text-white rounded-xl text-lg shadow-lg">
                <i className="ri-bar-chart-box-line"></i>
              </span>
              比較基準
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="flex items-center gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-100 text-amber-600 rounded-lg flex-shrink-0">
                  <i className="ri-percent-line"></i>
                </span>
                <span className="font-semibold text-gray-800">ポイント還元率</span>
              </div>
              <div className="flex items-center gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-100 text-amber-600 rounded-lg flex-shrink-0">
                  <i className="ri-money-yen-circle-line"></i>
                </span>
                <span className="font-semibold text-gray-800">年会費</span>
              </div>
              <div className="flex items-center gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-100 text-amber-600 rounded-lg flex-shrink-0">
                  <i className="ri-user-smile-line"></i>
                </span>
                <span className="font-semibold text-gray-800">初心者向けかどうか</span>
              </div>
              <div className="flex items-center gap-3 bg-white/60 rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-100 text-amber-600 rounded-lg flex-shrink-0">
                  <i className="ri-file-check-line"></i>
                </span>
                <span className="font-semibold text-gray-800">審査難易度の目安</span>
              </div>
              <div className="flex items-center gap-3 bg-white/60 rounded-lg p-4 sm:col-span-2">
                <span className="w-8 h-8 flex items-center justify-center bg-amber-100 text-amber-600 rounded-lg flex-shrink-0">
                  <i className="ri-gift-line"></i>
                </span>
                <span className="font-semibold text-gray-800">キャンペーン特典</span>
              </div>
            </div>
          </div>

          {/* 広告について */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 sm:p-8 border border-blue-100">
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-indigo-500 text-white rounded-xl text-lg shadow-lg">
                <i className="ri-advertisement-line"></i>
              </span>
              広告について
            </h3>
            <div className="bg-white/60 rounded-lg p-5">
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4">
                当サイトはアフィリエイト広告を利用しています。掲載されているリンクを経由してお申し込みいただいた場合、当サイトが紹介料を受け取ることがあります。
              </p>
              <div className="bg-blue-100 border-l-4 border-blue-500 p-4 rounded">
                <p className="text-gray-800 text-sm sm:text-base font-semibold">
                  <i className="ri-information-line text-blue-600 mr-2"></i>
                  しかし、報酬の高低ではなく「本当におすすめできるカード」を基準に掲載しています。
                </p>
              </div>
            </div>
          </div>

          {/* 情報更新日 */}
          <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl p-6 sm:p-8 border border-gray-200">
            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-gray-600 to-slate-600 text-white rounded-xl text-lg shadow-lg">
                <i className="ri-calendar-check-line"></i>
              </span>
              情報更新日
            </h3>
            <div className="bg-white/60 rounded-lg p-5">
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-3">
                最終更新日：<strong className="text-gray-900 text-lg">{year}年{month}月{day}日</strong>
              </p>
              <p className="text-gray-500 text-xs sm:text-sm">
                ※掲載情報は予告なく変更される場合があります。最新情報は各カード会社の公式サイトでご確認ください。
              </p>
            </div>
          </div>

          {/* 最後のメッセージ */}
          <div className="text-center bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-xl p-6 sm:p-8 shadow-lg">
            <p className="text-base sm:text-lg font-semibold leading-relaxed">
              読者の皆さまにとって<br className="sm:hidden" />
              <span className="text-xl sm:text-2xl font-bold">"最適な1枚"</span>を選べるサイトを目指しています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
